import React from 'react';

export const SvgVolumeMute = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7.5 10.005v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.415c0-.89-1.08-1.34-1.71-.71l-3.29 3.3h-3c-.55 0-1 .45-1 1z"
      fill="currentColor"
    />
  </svg>
);
